import PropTypes from 'prop-types';

export const ListPropTypes = {
  /**
   * Optional component used for rendering inside the list item
   * // todo: Defaults to <button> / <a> depending on
   *
   * @type {Element}
   */
  listItemComponent: PropTypes.element,
  /**
   * onClick function for specific list items
   *
   * @type {Function}
   */
  onClick: PropTypes.func,
};
